export default {
  header: "Achtung",
  changeasset:
    "Das Asset wurde inzwischen von einem anderen Benutzer aktualisiert und Ihre Änderungen können nicht gespeichert werden. Bitte versuchen Sie es erneut.",
};
